import { render, staticRenderFns } from "./MultiManuscriptEditorPage.vue?vue&type=template&id=4eaae09a&scoped=true"
import script from "./MultiManuscriptEditorPage.vue?vue&type=script&lang=ts"
export * from "./MultiManuscriptEditorPage.vue?vue&type=script&lang=ts"
import style0 from "./MultiManuscriptEditorPage.vue?vue&type=style&index=0&id=4eaae09a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eaae09a",
  null
  
)

export default component.exports